import { useState } from "react";

export default function BenefitsPage() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="h-screen w-full">
      {isLoading && (
        <div className="flex h-full items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900" />
        </div>
      )}
      <iframe
        src="https://projectsg-client-benefits.webxial.workers.dev/?embed=1"
        style={{
          minHeight: "100svh",
        }}
        className={`h-full min-h-screen w-full items-center justify-center border-0 ${isLoading ? "hidden" : "flex"}`}
        title="Benefits"
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
}
